<template>
    <div id="tile">
        <h1>This is a tile</h1>
        <h2>Tile ID: {{ tileId }}</h2>
    </div>
</template>


<script>
    export default {
        props: {
            tileId: ''
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Tile.vue